module.exports = __webpack_public_path__ + "static/pek-lum-35b372efe5d53750c1cf9a451584b249.png";